var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeStroke1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5013 24.0144L14.5012 24.0144C14.3521 23.963 14.2231 23.8838 14.1099 23.7742L14.1013 23.7659L14.0924 23.7581L12.6414 22.4812C12.6413 22.4811 12.6412 22.4811 12.6412 22.481C10.8604 20.9092 9.27332 19.3675 7.87891 17.856C6.53927 16.404 5.89999 14.8858 5.89999 13.2914C5.89999 12.0337 6.33201 11.0025 7.19846 10.1637C8.06581 9.32399 9.13889 8.90002 10.4526 8.90002C11.1906 8.90002 11.9248 9.06422 12.6591 9.40027C13.3675 9.72443 14.017 10.2575 14.6032 11.0221L15 11.5395L15.3968 11.0221C15.983 10.2575 16.6325 9.72443 17.3409 9.40027C18.0752 9.06422 18.8094 8.90002 19.5474 8.90002C20.8611 8.90002 21.9342 9.32399 22.8015 10.1637C23.668 11.0025 24.1 12.0337 24.1 13.2914C24.1 14.9037 23.4495 16.4397 22.086 17.9096C20.6676 19.4388 19.0842 20.9671 17.3354 22.4945L17.3341 22.4956L15.8981 23.7579L15.889 23.7659L15.8804 23.7742C15.7684 23.8826 15.6388 23.9619 15.4863 24.0137L15.4863 24.0137C15.3123 24.0728 15.1476 24.1 14.9903 24.1C14.833 24.1 14.6707 24.0728 14.5013 24.0144Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeStroke1);
export default __webpack_public_path__ + "static/media/Like-Stroke 1.8776634607c829c58e28c2eb804065f5.svg";
export { ForwardRef as ReactComponent };